// Define globally immediately
window.initCartCarousel = function() {
  console.log('initCartCarousel called');
  
  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.error('Swiper is not loaded yet, waiting...');
    setTimeout(window.initCartCarousel, 100);
    return;
  }

  // Destroy existing instance if any
  const existingCarousel = document.querySelector('.upsell-carousel');
  console.log('Found carousel element:', existingCarousel);
  
  if (existingCarousel && existingCarousel.swiper) {
    console.log('Destroying existing swiper instance');
    existingCarousel.swiper.destroy(true, true);
  }

  // Initialize new Swiper
  if (existingCarousel) {
    console.log('Initializing new Swiper instance');
    var swiper = new Swiper(".upsell-carousel", {
      grabCursor: true,
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {},  
    });
    console.log('Cart carousel initialized successfully', swiper);
    return swiper;
  } else {
    console.log('No .upsell-carousel element found');
  }
};

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.initCartCarousel);
} else {
  window.initCartCarousel();
}